import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../core/services/common.service";
import { CocService } from "../coc.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TokenService } from "src/app/core/services/token.service";
import { Router } from "@angular/router";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { ValidateVehiculo } from "../../certificates/models";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-request",
  templateUrl: "./request.component.html",
  styleUrls: ["./request.component.scss"],
})
export class RequestComponent implements OnInit {
  requestType: string = "individual";
  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;
  @ViewChild("excelInputFile") excelInputFile: ElementRef<HTMLInputElement>;
  requestCOC: FormGroup;
  currentTargetId: string;
  file = {
    file: null,
    name: "",
  };
  excel = {
    file: null,
    name: "",
  };
  nameAuxFile: string;
  requestText: string;
  vehiculoValid: boolean;
  routing = RoutingConstants.cocRequest;

  constructor(
    private commonService: CommonService,
    private cocService: CocService,
    private toastrAlertService: ToastrAlertService,
    private SweetAlertService: SweetAlertService,
    private router: Router,
    private tokenService: TokenService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.initFormIndividual();
    this.requestText = this.translateService.instant("messages.requestText");
  }

  changeCertificateType(e) {
    this.requestType = e.target.value;
    switch (this.requestType) {
      case "individual":
        this.initFormIndividual();
        break;
      case "masiva":
        this.initFormMasivo();
        break;
      case "leasing":
        this.initFormMasivoLeasing();
        break;
    }
  }

  initFormIndividual() {
    if (this.requestCOC) {
      this.requestCOC.get("bastidor")?.enable();
      this.requestCOC.get("primerMatriculacion")?.disable();
    }

    this.requestCOC = new FormGroup({
      requestType: new FormControl("CC", [Validators.required]),
      bastidor: new FormControl("", [
        Validators.maxLength(128),
        Validators.required,
      ]),
      primerMatriculacion: new FormControl("", [Validators.required]),
      file: new FormControl(""),
      observacion: new FormControl(""),
    });

    this.vehiculoValid = false;
    this.requestCOC.get("primerMatriculacion")?.disable();
  }

  initFormMasivo() {
    this.requestCOC = new FormGroup({
      requestType: new FormControl("CM", [Validators.required]),
      excel: new FormControl(""),
      numBastidores: new FormControl("", [Validators.required]),
      marca: new FormControl(
        this.getMarcaPreseleccionadaParaMasivos(),
        Validators.required
      ),
      observacion: new FormControl(""),
    });
  }

  initFormMasivoLeasing() {
    this.requestCOC = new FormGroup({
      requestType: new FormControl("CML", [Validators.required]),
      excel: new FormControl(""),
      numBastidores: new FormControl("", [Validators.required]),
      fileDocumentacion: new FormControl(""),
      marca: new FormControl(
        this.getMarcaPreseleccionadaParaMasivos(),
        Validators.required
      ),
      observacion: new FormControl(""),
    });
  }

  getMarcaPreseleccionadaParaMasivos() {
    let marcaPreseleccionada = "";
    if (this.soloPuedeElegirSeat()) {
      marcaPreseleccionada = "SEAT";
    } else if (this.soloPuedeElegirVolkswagen()) {
      marcaPreseleccionada = "VOLKS";
    }
    return marcaPreseleccionada;
  }

  handleFileInput(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (
        Array.from(fileInput.target.files).filter(
          (file: File) =>
            file.name.length > AppConstants.maximaLongitudNombreFichero
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileNameExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      if (
        Array.from(fileInput.target.files).filter(
          (file: File) => file.size > AppConstants.tamanyoMaximoFicheroEnBytes
        ).length > 0
      ) {
        let message = this.translateService.instant(
          "messages.maxFileSizeExceeded"
        );
        this.toastrAlertService.toastrFail(message);
        return;
      }

      this.currentTargetId = fileInput.currentTarget.id;
      this.nameAuxFile = fileInput.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let blob = this.commonService.castToBlob(e.target.result);
        switch (this.currentTargetId) {
          case "fichero":
            this.file.file = blob;
            this.file.name = this.nameAuxFile;
            break;
          case "excel":
            this.excel.file = blob;
            this.excel.name = this.nameAuxFile;
            break;
          case "documentacion":
            this.file.file = blob;
            this.file.name = this.nameAuxFile;
            break;
        }
      };

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  changeBrand(e) {
    this.requestCOC.value.marca = e.target.value;
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.requestCOC.controls
    );

    if (this.requestType == "individual") {
      if (invalidFields.length > 0 || !this.file.file) {
        let text = this.commonService.getValueOfLabelsById(invalidFields);

        if (!this.file.file) {
          text = text + "Documentación (requerido)";
        }

        this.toastrAlertService.toastrFail(text);
      } else {
        this.saveIndividual();
      }
    } else if (this.requestType == "masiva") {
      if (invalidFields.length > 0 || !this.excel.file) {
        let text = this.commonService.getValueOfLabelsById(invalidFields);

        if (!this.excel.file) {
          text = text + "Excel (requerido)";
        }

        this.toastrAlertService.toastrFail(text);
      } else {
        this.saveMasiva();
      }
    } else if (this.requestType == "leasing") {
      if (invalidFields.length > 0 || !this.excel.file || !this.file.file) {
        let text = this.commonService.getValueOfLabelsById(invalidFields);

        if (!this.excel.file) {
          text = text + "Excel (requerido) <br/>";
        }

        if (!this.file.file) {
          text = text + "Documentación (requerido)";
        }
        this.toastrAlertService.toastrFail(text);
      } else {
        this.saveMasivaLeasing();
      }
    }
  }

  validateVehiculo() {
    let dto: ValidateVehiculo = {
      bastidor: this.requestCOC.getRawValue().bastidor,
      matricula: "0000BBB",
    };

    this.SweetAlertService.sweetAlertLoading();
    this.cocService.validateVehiculoBastidor(dto).subscribe(
      (data) => {
        this.vehiculoValid = true;
        this.requestCOC.get("bastidor")?.disable();
        this.requestCOC.get("primerMatriculacion")?.enable();
        this.requestCOC.get("file")?.enable();
        this.requestCOC.get("observacion")?.enable();
        this.SweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al validar el bastidor"
        );
        this.SweetAlertService.sweetAlertClose();
      }
    );
  }

  saveIndividual() {
    let form = {
      peticionesDto: {
        peObservaciones: this.requestCOC.value.observacion,
        peBastidor: this.requestCOC.getRawValue().bastidor,
        peCertificadoCoC: this.requestCOC.value.requestType,
        peFecPriMat: this.requestCOC.value.primerMatriculacion,
      },
      detallePeticionesDto: [
        {
          dpCampoid: "PE_EXCEL",
          dpFichero: this.file.name,
        },
      ],
    };
    this.SweetAlertService.sweetAlertLoading();
    this.cocService.sendRequest(form, this.file).subscribe(
      (data) => {
        this.confirmSwal.text = data.mensaje;
        this.confirmSwal.fire();
        this.SweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.SweetAlertService.sweetAlertClose();
      }
    );
  }

  saveMasiva() {
    let form = {
      peticionesDto: {
        peObservaciones: this.requestCOC.value.observacion,
        peCoCNumBastidores: this.requestCOC.value.numBastidores.toString(),
        peCertificadoCoC: this.requestCOC.value.requestType,
        peMarcaVehiculos: this.requestCOC.value.marca,
      },
      detallePeticionesDto: [
        {
          dpCampoid: "PE_EXCEL",
          dpFichero: this.excel.name,
        },
      ],
    };
    this.SweetAlertService.sweetAlertLoading();
    this.cocService.sendRequestMasiva(form, this.excel).subscribe(
      (data) => {
        this.confirmSwal.text = data.mensaje;
        this.confirmSwal.fire();
        this.SweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.excelInputFile.nativeElement.value = null;
        this.excel.file = null;
        this.excel.name = null;
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.SweetAlertService.sweetAlertClose();
      }
    );
  }

  saveMasivaLeasing() {
    let form = {
      peticionesDto: {
        peObservaciones: this.requestCOC.value.observacion,
        peCoCNumBastidores: this.requestCOC.value.numBastidores.toString(),
        peCertificadoCoC: this.requestCOC.value.requestType,
        peMarcaVehiculos: this.requestCOC.value.marca,
      },
      detallePeticionesDto: [
        {
          dpCampoid: "PE_EXCEL",
          dpFichero: this.excel.name,
        },
        {
          dpCampoid: "PE_DOCADICIONAL",
          dpFichero: this.file.name,
        },
      ],
    };
    this.SweetAlertService.sweetAlertLoading();
    this.cocService
      .sendRequestMasivaLeasing(form, this.file, this.excel)
      .subscribe(
        (data) => {
          this.confirmSwal.text = data.mensaje;
          this.confirmSwal.fire();
          this.SweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.excelInputFile.nativeElement.value = null;
          this.excel.file = null;
          this.excel.name = null;
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.SweetAlertService.sweetAlertClose();
        }
      );
  }

  goList() {
    this.router.navigate([this.routing.mailBoxList]);
  }

  createAnotherRequest() {
    window.location.reload();
  }

  public puedeElegirSeat() {
    if (
      this.tokenService.hasRole(AppConstants.roles.CONCES) &&
      this.tokenService.getRegionDelConcesionario() == "VOLKSWAGEN"
    )
      return false;
    return true;
  }

  public puedeElegirVolkswagen() {
    if (
      this.tokenService.hasRole(AppConstants.roles.CONCES) &&
      this.tokenService.getRegionDelConcesionario() == "SEAT"
    )
      return false;
    return true;
  }

  private soloPuedeElegirSeat() {
    if (!this.tokenService.hasRole(AppConstants.roles.CONCES)) return false;
    return this.tokenService.getRegionDelConcesionario() == "SEAT";
  }

  private soloPuedeElegirVolkswagen() {
    if (!this.tokenService.hasRole(AppConstants.roles.CONCES)) return false;
    return this.tokenService.getRegionDelConcesionario() == "VOLKSWAGEN";
  }

  public setNumber() {
    if (
      !this.requestCOC.value.numBastidores ||
      this.requestCOC.value.numBastidores < AppConstants.minNumPuertas
    ) {
      let message =
        document.getElementById("numBastidores").textContent +
        this.translateService.instant("messages.numeroMinInt");
      this.toastrAlertService.toastrFail(message);
      this.requestCOC.patchValue({
        numBastidores: AppConstants.defaultNumPuertas,
      });
    }
  }
}
